<ion-header
  class="ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label data-cy="select-issue-label">
      {{ 'i18n.requestCredit.selectIssue' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="serviceRequestService?.issues$ | async as issues"
  class="issue-options_content"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <div
    *ngIf="!issues?.length"
    class="no-data-found"
    data-cy="no-data-found-text"
  >
    <p>
      {{ 'i18n.requestCredit.noIssuesFound' | translate }}
    </p>
  </div>
  <ion-list *ngIf="issues?.length" class="issues-list">
    <ion-item-divider></ion-item-divider>
    <ion-item
      *ngFor="let issue of issues; let i = index"
      id="issue-number-{{ i }}"
      detail="true"
      (click)="getIssueDetails(issue)"
      data-cy="get-issue-details"
      [class.selected]="
        serviceRequestService?.modalRelatedParams?.issue === issue
      "
    >
      <ion-label>
        <p class="info-top" data-cy="issue-display-text">
          {{ issue?.displayText }}
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-issue-options-modal-button"
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.tablet
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismissModal(true)"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
